import {NgModule} from '@angular/core';
import {MaskedAadhaarInfoComponent} from './masked-aadhaar-info.component';

@NgModule({
    declarations: [MaskedAadhaarInfoComponent],
    exports: [MaskedAadhaarInfoComponent]
})
export class MaskedAadhaarInfoModule {
}